import type { ComponentProps } from 'react';
import { ProposalStatus } from '@/api/commercial/proposals';
import { Badge } from '@/components/ui/badge';

const STATUS_LABEL: Record<
  ProposalStatus,
  { label: string; variant: ComponentProps<typeof Badge>['variant']; className?: string }
> = {
  [ProposalStatus.OPEN]: {
    label: 'Aberta',
    variant: 'warning-subtle',
  },
  [ProposalStatus.PENDING_ACCEPT]: {
    label: 'Aguardando aceite',
    variant: 'info-subtle',
  },
  [ProposalStatus.ACCEPTED_PENDING_PAYMENT]: {
    label: 'Aceita – Aguardando pagamento',
    variant: 'warning-subtle',
  },
  [ProposalStatus.PENDING_CREDIT]: {
    label: 'Aguardando Analise de Credito',
    variant: 'info-subtle',
  },
  [ProposalStatus.FINISHED]: {
    label: 'Finalizada',
    variant: 'success-subtle',
  },
  [ProposalStatus.CANCELED]: {
    label: 'Cancelada',
    variant: 'destructive-subtle',
  },
  [ProposalStatus.REFUSED]: {
    label: 'Recusada',
    variant: 'destructive-subtle',
  },
  [ProposalStatus.EXPIRED]: {
    label: 'Expirada',
    variant: 'warning-subtle',
    className: 'border-orange-200 bg-orange-50 text-orange-700',
  },
};

interface ProposalStatusBadgeProps {
  status?: ProposalStatus | string;
}

export function ProposalStatusBadge({ status }: ProposalStatusBadgeProps) {
  if (!status) {
    return null;
  }

  const config = STATUS_LABEL[status as ProposalStatus] ?? {
    label: status,
    variant: 'secondary-subtle' as const,
    className: undefined,
  };

  return (
    <Badge variant={config.variant} className={config.className}>
      {config.label}
    </Badge>
  );
}
